import { render, staticRenderFns } from "./observations.vue?vue&type=template&id=bca12f2a&scoped=true"
import script from "./observations.vue?vue&type=script&lang=js"
export * from "./observations.vue?vue&type=script&lang=js"
import style0 from "./observations.vue?vue&type=style&index=0&id=bca12f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca12f2a",
  null
  
)

export default component.exports